<template>
    <div class="trainer__show">
        <div class="trainer__show_header">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="trainer__show_header_details">
                            <div class="columns is-vcentered">
                                <div class="column custom--center">
                                    <view-actions
                                        v-if="user.isEventCoordinator()"
                                        :title="trainerName"
                                        :size="'small'"
                                        :notify-title="$t('ebs.trainers.show.notifyTitle')"
                                        :trash-button-active="isSecondStageTokenFromOldLMS"
                                        :cancel-button-active="false"
                                        :submit-button-text="$t('ebs.trainers.show.buttonEdit')"
                                        :breadcrumb-active="true"
                                        :breadcrumb-items="[
                                            {
                                                name: this.$t('ebs.trainers.show.nameTrainer'),
                                                to: { name: 'ebs-trainer-list' }
                                            }
                                        ]"
                                        @emit-notify-remove-submit="trainerRemove"
                                        @emit-submit="trainerEdit"
                                    />
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column custom--center">
                                    <component-contact
                                        :title="''"
                                        :email="trainerEmail"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="trainerImages.length">
                        <div class="column is-narrow">
                            <div class="trainer__show_header_image">
                                <component-slider
                                    :images="trainerImages"
                                    :alt="trainerName"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="trainer__show_main">
            <div class="container">
                <div class="columns custom--center">
                    <div class="column is-4-widescreen is-9-tablet is-12-mobile">
                        <component-hours
                            :title="$t('ebs.trainers.show.titleHours')"
                            :items="trainerWorkingHours"
                        />
                    </div>
                    <div class="column is-1 custom--none"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentContact from '@/components/default/shared/ComponentContact'
import ComponentHours from '@/components/default/shared/ComponentHours'
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'
import ComponentSlider from '@/components/default/shared/ComponentSlider'

export default {
  components: {
    ComponentSlider,
    ViewActions,
    ComponentHours,
    ComponentContact
  },
  name: 'trainer-show',
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData)
    }
  },
  computed: {
    isSecondStageTokenFromOldLMS () {
      return this.$store.getters.getAuthUserIsSecondStageTokenOldLMS
    },
    trainerId: function () {
      return this.$store.getters['getTrainerId']
    },
    trainerName: function () {
      return this.$store.getters['getTrainerName']
    },
    trainerEmail: function () {
      return this.$store.getters['getTrainerEmail']
    },
    trainerImages: function () {
      return this.$store.getters.getTrainerImage.map(image => {
        return image.fileId
      })
    },
    trainerWorkingHours: function () {
      return this.$store.getters['getTrainerWorkingHours']
    }
  },
  methods: {
    trainerEdit: function () {
      this.$router.push({ name: 'ebs-trainer-edit', params: { id: this.trainerId } })
    },
    trainerRemove: function () {
      const trainerId = this.$route.params.id
      this.$store.dispatch('removeTrainer', trainerId)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/trainers/trainershow";
</style>
